import Swiper, {Lazy, Navigation, Pagination} from 'swiper';
import 'swiper/swiper-bundle.css';

export default class PageGallery {
  private readonly swiper: Array<Swiper>;

  constructor(selector: string = ".swiper-container") {
    this.swiper = this.createSwiper(selector);

    this.initEventListeners();
  }

  private createSwiper = (selector: string) => {
    Swiper.use([Navigation, Pagination, Lazy]);
    return new Swiper(selector, {
      direction: 'horizontal',
      loop: true,
      preloadImages: false,
      lazy: {
        enabled: true,
        loadPrevNext: false,
        checkInView: true,
        loadOnTransitionStart: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
    }) as unknown as Array<Swiper>;
  };

  private initEventListeners() {
    if (this.swiper && this.swiper.length > 0) {
      this.swiper.forEach((swipe) => {
        this.setTotalImageValue(swipe.el);

        swipe.on('slideChange', (swipeElement) => {
          this.setTotalImageValue(swipeElement.el);
        });
      });
    }
  }

  private setTotalImageValue(swipe: Element) {
    if (swipe.hasAttribute("data-total-images")) {
      const paginationTotal = swipe.querySelector(".swiper-pagination-total") as HTMLElement
      if (paginationTotal) {
        paginationTotal.innerHTML = swipe.getAttribute("data-total-images")!;
      }
    }
  }
}
